import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { CardSwapDialog as CardSwapDialogDumb } from '@sorare/core/src/components/cardswap/Dialog';
import { CardSwapContextProvider } from '@sorare/core/src/components/cardswap/useCardSwapContext';

import { ConfirmSwap } from '../steps/ConfirmSwap';
import { PickCardToReceive } from '../steps/PickCardToReceive';
import { PickCardToSwap } from '../steps/PickCardToSwap';
import { WelcomeToTheTeam } from '../steps/WelcomeToTheTeam';
import { useCompleteTradeMutation } from '../useCompleteTradeMutation';

const STEPS = [
  PickCardToSwap,
  PickCardToReceive,
  ConfirmSwap,
  WelcomeToTheTeam,
];

type Props = {
  open: boolean;
  onClose: () => void;
};
export const CardSwapDialog = ({ open, onClose }: Props) => {
  const submitTrade = useCompleteTradeMutation();
  return (
    <CardSwapContextProvider sport={Sport.NBA} nbSteps={STEPS.length}>
      <CardSwapDialogDumb
        open={open}
        steps={STEPS}
        cancelTrade={async () => {
          await submitTrade(null);
          onClose();
        }}
        onClose={onClose}
        completeTrade={async (userReceiveCardSampleId: string) => {
          await submitTrade(userReceiveCardSampleId);
        }}
      />
    </CardSwapContextProvider>
  );
};
